<template>
  <div>
    <div class="position">
      <span
        >您现在的位置：<a href="/">首页</a> > 西安12345政务服务便民热线
        >诉求详情</span
      >
      <div>
        <span>
          <a href="/">首页</a>
          <span>/</span>
        </span>
        <span>
          <a>互动</a>
        </span>
      </div>
    </div>
    <div class="container">
      <div class="orderInfo">
        <div class="top" v-if="false">
          <div class="title">联系信息</div>
          <el-row class="bordTop">
            <el-col :span="9">
              <div class="key">姓名</div>
              <div class="value">{{ order.name }}</div>
            </el-col>
            <el-col :span="9">
              <div class="key w_25">性别</div>
              <div class="value"></div>
            </el-col>
            <el-col :span="6">
              <div class="key">联系方式</div>
              <div class="value">{{ order.telephone }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <div class="key">邮箱</div>
              <div class="value"></div>
            </el-col>
            <el-col :span="15">
              <div class="key w_15">联系地址</div>
              <div class="value w_85"></div>
            </el-col>
          </el-row>
        </div>
        <div class="middle">
          <div class="title">诉求信息</div>
          <el-row class="bordTop">
            <el-col :span="9">
              <div class="key">工单编号</div>
              <div class="value">
                {{ order.orderNo ? order.orderNo : "*********" }}
              </div>
            </el-col>
            <el-col :span="15">
              <div class="key w_15">信件名称</div>
              <div class="value w_85">{{ order.title }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <div class="key">信件分类</div>
              <div class="value">
                {{ order.typeIndex}}
              </div>
            </el-col>
            <el-col :span="15">
              <div class="key w_15">受理时间</div>
              <div class="value w_85">
                {{order.createTime? formatDateTime(order.createTime):''}}
              </div>
            </el-col>
          </el-row>
         <el-row v-if="orderNoWin">
           <el-col :span="24">
             <div class="key w_10 table">上传附件</div>
             <div class="value table">
               <el-link
                       @click="openFile(item)"
                       icon="el-icon-view"
                       type="primary"
                       class="file-link"
                       v-for="(item, index) in fileList"
                       :key="index"
               >
                 {{ item.filename }}
               </el-link>
             </div>
           </el-col>
         </el-row> 
          <el-row>
            <el-col :span="24">
              <div class="key long_key w_10">信件内容</div>
              <div class="value w_85 media" style="white-space: pre-wrap;" v-html="order.callerContent"></div>

            </el-col>
          </el-row>
        </div>
        <div class="bottom">
          <div class="title">回复内容</div>
          <el-row class="bordTop">
            <el-col :span="9">
              <div class="key">回复部门</div>
              <!-- 办理方式  是直接答复 -->
              <div class="value" style="cursor:pointer;" :title="order.resultHandling ?order.upReportDept :''">
                {{ order.resultHandling ?order.upReportDept : "" }}
              </div>
            </el-col>
            <el-col :span="15">
              <div class="key w_15">办结时间</div>
              <div class="value w_85" >
                {{ order.resultHandling ?order.upReportTime ? formatDateTime(order.upReportTime): "": "" }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="key w_10 long_key">回复内容</div>
              <div class="value w_85 media white-space">{{ order.resultHandling}}</div>
<!--              <div class="value w_85 media white-space" v-else>{{order.resultHandling &&(state == "待评价" || state == "已归档") &&showResult? order.resultHandling: "正在办理中"}}</div>-->
            </el-col>
          </el-row>
          <el-row v-if="state == '待评价'&&orderNoWin">
              <el-col :span="24">
                <div class="key w_10">满意度评价</div>
                <div class="value w_85 media">
                  <el-radio-group v-model="myd">
                    <el-radio :label="3">非常满意</el-radio>
                    <el-radio :label="2">满意</el-radio>
                    <el-radio :label="1">理解</el-radio>
                    <el-radio :label="0">不满意</el-radio>
                  </el-radio-group>
                  <el-button @click="sub" :loading="evaLoading">确定</el-button>
                </div>
              </el-col>
            </el-row>
          <el-row v-if="state == '已完结'&&orderNoWin">
              <el-col :span="24">
                <div class="key w_10">满意度评价</div>
                <div class="value w_85 media">
                  {{ order.zxAppraise | formatAppraise }}
                </div>
              </el-col>
            </el-row>
            <el-row v-if="!orderNoWin">
              <el-col :span="24">
                <div class="key w_10">满意度评价</div>
                <div class="value w_85 media" v-if="order.zxAppraise != -1">{{order.zxAppraise | formatAppraise}}
                </div>
                <div class="value w_85 media" v-else>您可以在‘我的诉求’里对您的工单进行评价。</div>
              </el-col>
            </el-row>

        </div>
      </div>
      <div class="right">
        <hotline />
      </div>
    </div>
  </div>
</template>

<script>
import hotline from "@/components/hotline";
import conf from "@/config";
import "@/assets/styles/loc.css";
// import { Base64 } from 'js-base64';

export default {
  name: "orderInfo",
  data() {
    return {
      order: {},
      state: "",
      myd: 3,
      fileList: [],
      handleInfoName: "",
      showResult: false,
      orderNoWin: true,
      evaLoading:false,
    };
  },
  components: {
    hotline,
  },
  methods: {
    sub() {
      this.$confirm("确认评价吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.evaLoading = true;
          this.evaluate();
        })
        .catch(() => {});
    },
    //获取orderId
    getOrderId(order) {
      let orderId = order.orderId;
      let dataId = order.dataId;
      if (orderId != undefined) {
        return orderId + "";
      } else {
        return dataId;
      }
    },
    //在新窗口打开附件
    openFile(item) {
      if(item.name.startsWith('http')) {
        // const url = conf.webApi + "/static/" + item.name
        window.open(item.name);
      }else {
        this.downFile(item);
      }
    },
    downFile(item){
      let params = {
        attachmentUrl:item.code
      };
      this.webAxios({
          url:"/portal/orderApi/download",
          method:"get",
          responseType:"arraybuffer",
          params:params,
          timeout:1200000
        }).then( async res => {
        const link = document.createElement("a");
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob); // 创建URL
        link.href = objectUrl;
        link.download = item.name; // 自定义文件名
        link.click(); // 下载文件
        URL.revokeObjectURL(objectUrl); // 释放内存
      })
    },
    getOrderInfo(params) {
      let telephone = localStorage.getItem('callPhone')
      this.gwCommunication('/portal/orderApi/get_order_detail',params,telephone,(res) => {
        if (res.data.code == 200) {
            this.order = res.data.data.data;
            this.order.sourceTwo = this.order.orderOrigin2Name;
            this.fileList = []
            if(this.order.attachmentUrls&&this.order.attachmentUrls.length) {
              for (let i = 0; i < this.order.attachmentUrls.length; i++) {
                const element = this.order.attachmentUrls[i];
                const item = {
                  filename: '附件'+ (i*1+1),
                  ...element
                };
                this.fileList.push(item);
              }
            }
            if (this.order.sourceTwo == "官网"||this.order.sourceTwo == "市长信箱") {
              if (this.order.slave != null &&(this.order.slave.openState == 36 ||this.order.slave.openState == 37)) {
                this.showResult = true;
              } else {
                this.showResult = false;
              }
            } else {
              this.showResult = true;
            }
          } else {
            this.order = JSON.parse(sessionStorage.getItem("order-row"));
          }
      })
    },
    getOrderById(orderNo) {
      let params = {
        orderNo: orderNo,
      };
      webAxios
        .post("/portal/orderApi/getOrderByOrderNo", params)
        .then((res) => {
          // console.log(res.data);
          if (res.data.code == 200) {
            this.order = res.data.data.data;

            this.order.sourceTwo = this.order.orderOrigin2Name;
            // console.log("this.order",this.order.sourceTwo);
            if (this.order.attachmentUrls !=''){
              let arr = this.order.attachmentUrls.split(",")
              if (arr != null) {
                for (let i = 0; i < arr.length; i++) {
                  let item = {
                    name: '附件'+ (i*1+1),
                    url: conf.webApi + "/static/" + arr[i],
                  };
                  this.fileList.push(item);
                }
              }
            }


            //////////////////////////////////////////////////////////////////////////////////
            if (this.order.sourceTwo == "官网"||this.order.sourceTwo == "市长信箱") {
              if (this.order.slave != null &&(this.order.slave.openState == 36 ||this.order.slave.openState == 37)) {
                console.log("this.showResult:",this.showResult)
                this.showResult = true;
              } else {
                this.showResult = false;
              }
            } else {
              console.log(1111111111111111111)
              this.showResult = true;
            }

           ///////////////////////////////////////////////////////////////////////////////////
           // if(this.order.handleType == 1 && this.order.orderState == 99 && this.order.orderSubState == 99){
           //   if(this.order.resultHandling ){
           //      ///////////// resultHandling
           //   }else{
           //     if(this.order.acceptCenterIdea){
           //      this.order.resultHandling = this.order.acceptCenterIdea;
           //     }
           //   }
           // }

          } else {
            this.order = JSON.parse(sessionStorage.getItem("order-row"));
          }
        })
        .catch((error) => {
          // this.order = JSON.parse(sessionStorage.getItem("order-row"));
        });

    },
    getOrderByIds(orderNo) {
      let params = {
        orderNo: orderNo,
      };
      webAxios
              .post("/portal/orderApi/getOpenOrderByOrderNo", params)
              .then((res) => {
                console.log(res);
                if (res.data.code == 200) {
                  this.order = res.data.data.data;

                  this.order.sourceTwo = this.order.orderOrigin2Name;
                  // console.log("this.order",this.order.sourceTwo);
                  if (this.order.attachmentUrls !=''){
                    let arr = this.order.attachmentUrls.split(",")
                    if (arr != null) {
                      for (let i = 0; i < arr.length; i++) {
                        let item = {
                          name: '附件'+ (i*1+1),
                          url: conf.webApi + "/static/" + arr[i],
                        };
                        this.fileList.push(item);
                      }
                    }
                  }


                  //////////////////////////////////////////////////////////////////////////////////
                  if (this.order.sourceTwo == "官网"||this.order.sourceTwo == "市长信箱") {
                    if (this.order.slave != null &&(this.order.slave.openState == 36 ||this.order.slave.openState == 37)) {
                      console.log("this.showResult:",this.showResult)
                      this.showResult = true;
                    } else {
                      this.showResult = false;
                    }
                  } else {
                    console.log(1111111111111111111)
                    this.showResult = true;
                  }

                  ///////////////////////////////////////////////////////////////////////////////////
                  // if(this.order.handleType == 1 && this.order.orderState == 99 && this.order.orderSubState == 99){
                  //   if(this.order.resultHandling ){
                  //      ///////////// resultHandling
                  //   }else{
                  //     if(this.order.acceptCenterIdea){
                  //      this.order.resultHandling = this.order.acceptCenterIdea;
                  //     }
                  //   }
                  // }

                }
              })
              .catch((error) => {
                // this.order = JSON.parse(sessionStorage.getItem("order-row"));
              });

    },
    isSolveProblem() {
      let params = {
        dictCode: "sfjjlwt",
        isCache: true,
      };
      webAxios
        .post("/portal/dict/findSonByDictCode", params)
        .then((response) => {
          if (response.data.code == 200) {
            let jjwt = response.data.data;
            jjwt.forEach((item) => {
              if (conf.dictId == item.dictId) {
                this.handleInfoName = item.dictName;
              }
            });
          }
        });
    },
    //评价
    evaluate() {
      this.params = {
        orderId: this.order.orderId,
        callbackInfo: "", //评价内容(回访情况)
        isPublic: 0, //是否公开
        satisfactionss: this.myd, //服务态度评价
        handleInfo: conf.dictId, //是否解决了问题
        handleInfoName: this.handleInfoName, //是否解决了问题名
        zxAppraise: this.myd, //办理结果评价
      };
      let telephone = localStorage.getItem('callPhone')
      this.gwCommunication('/portal/orderApi/qz_appraise',this.params,telephone,(res) => {
        if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "评价成功",
            });
            setTimeout(() => {
              this.$router.push({
                name: "orderList",
              });
            }, 200);
          } else {
            this.evaLoading = false;
            this.$message({
              type: "error",
              message: "提交失败，请刷新后重新尝试！",
            });
          }
      })
      // webAxios
      //   .post("/portal/orderApi/qzAppraise", this.params)
      //   .then((res) => {
      //     this.evaLoading = false;
      //     if (res.data.code == 200) {
      //       this.$message({
      //         type: "success",
      //         message: "评价成功",
      //       });
      //       setTimeout(() => {
      //         this.$router.push({
      //           name: "orderList",
      //         });
      //       }, 200);
      //     } else {
      //       this.evaLoading = false;
      //       this.$message({
      //         type: "error",
      //         message: "提交失败，请刷新后重新尝试！",
      //       });
      //     }
      //   })
      //   .catch(() => {
      //     this.evaLoading = false;
      //     this.$message({
      //       type: "error",
      //       message: "提交失败，请刷新后重新尝试！",
      //     });
      //   });
    },
  },

  created() {
    //省平台authCheck校验未通过会带回flag参数，需重新发起认证跳转
    let flag = this.getUrlParams("flag");
    if (flag) {
      this.login();
      return;
    }
    //处理省统一身份认证平台回调的授权码，换取用户信息
    let code = this.getUrlParams("code");
    if(code){
      this.getUserInfoNew(code,res=>{
        if (res.code == 200) {
              localStorage.setItem("token",res.data.token);
              localStorage.setItem("callPhone",res.data.callPhone);
              localStorage.setItem("name",res.data.name);
              localStorage.setItem("orderType1",'1');
              this.$store.commit('isLogin','1')
            }
      });
    }
    //获取工单详情
    let orderNo= this.$route.query.order
    let order = JSON.parse(sessionStorage.getItem("order-row"));
    const params = {
      orderNo
    }
    if(orderNo) {
      this.orderNoWin=false;
    }else {
      params.orderNo = order.orderNo
      this.orderNoWin=true;
    }
    this.getOrderInfo(params);

    this.state = order && order.orderStateName?order.orderStateName : '';
    this.isSolveProblem();
  },
};
</script>

<style scoped>
@media screen and (max-width: 1200px) {
  /* .container{
        position: static;
        padding: 0px;
    } */
}
@media screen and (max-width: 1150px) {
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0px;
    padding: 0px;
  }

  body .orderInfo {
    width: 95%;
    margin-right: 0px;
    padding: 0px;
    order: 2;
    /* display: flex; */
    justify-content: center;
  }
  body .right {
    width: 95%;
    order: 1;
    margin-bottom: 15px;
  }
  body .el-col-9,
  body .el-col-15,
  body .w_10 {
    width: 100%;
  }
  body .w_15 {
    width: 30%;
  }
  body .w_85 {
    width: 65%;
  }
  body .media {
    width: 100%;
    display: block;
    /* border-left: 1px solid #e3e3e3; */
  }
  body .bottom {
    padding: 0;
  }
  body .bottom button {
    margin: 20px auto;
    display: flex;
    justify-content: center;
  }
  body .el-radio {
    display: block;
    margin-top: 20px;
  }
  body .value {
    vertical-align: middle;

  }
}
.container {
  display: flex;
  justify-content: space-between;
}
.orderInfo {
  width: 75%;
  margin-right: 20px;
}
.top,
.middle,
.bottom {
  background: #fff;
  padding: 0 15px 15px 15px;
}
.title {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #306bbb;
  line-height: 24px;
  padding: 16px 0;
  border-top: 3px solid #306bbb;
  width: 90px;
  text-align: center;
}
.middle,
.bottom {
  margin-top: 15px;
}
.bottom button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  border-radius: 15px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 30px;
  width: 92px;
  height: 30px;
  background: linear-gradient(0deg, #306bbb, #2d85fd);
  border-radius: 15px;
  color: #ffffff;
  margin-left: 20px;
  cursor: pointer;
}
.zhu {
  color: #f82020;
  font-size: 14px;
}
.right {
  width: 25%;
}
.key {
  box-sizing: border-box;
  width: 30%;
  background: #f5f5f5;
  color: #306bbb;
  text-align: center;
  line-height: 45px;
  /* border-left: 1px solid #e3e3e3; */
  border-right: 1px solid #e3e3e3;
}
.value {
  background: #ffffff;
  color: #666666;
  padding: 0 10px;
  box-sizing: border-box;
  width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.white-space {
  white-space: pre-wrap;
}
.el-row {
  box-sizing: border-box;
  border-left: 1px solid #e3e3e3;
  border-right: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
}
.el-row div {
  /* height: 45px; */
  display: inline-block;
}
.bordTop {
  border-top: 1px solid #e3e3e3;
}
.w_10 {
  width: 11.3%;
}
.w_15 {
  width: 15%;
}
.w_25 {
  width: 25%;
}
.w_30 {
  width: 30%;
}
.w_85 {
  width: 85%;
  word-wrap: break-word;
}
.long_key {
  min-height: 20px;
  /* height: 200px;
  line-height: 200px; */
  vertical-align: top;
}
</style>
<style>
</style>
